// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__3iOFV","spinner":"preloader_spinner__3O18E","spin":"preloader_spin__3PVqV"};